
import { Component, Vue } from "vue-property-decorator";
import CustomHtmlComponent from "@/components/CustomHtmlComponent.vue";
import Axios from "axios";

@Component({ components: { CustomHtmlComponent } })
export default class Home extends Vue {
  private confirmed = false;
  private htmlContent = "";

  beforeCreate() {
    Axios.get("/terms-and-conditions.html").then(htmlContent => {
      this.htmlContent = htmlContent.data;
    });
  }
}
